import { InputItemCategory } from "@kg-pos/common";

export const itemCategoryOptions = Object.entries(InputItemCategory).map((category) => ({
  label: category[1],
  value: category[0],
}));
